export default __webpack_public_path__ + "/assets/fonts/inria-serif-latin-ext-300-normal.woff2";